import { jsxs as o, jsx as l } from "react/jsx-runtime";
import { useUtilityAlertIconStyle as s } from "./index.es5639.js";
const d = ({
  variant: C = "outline",
  size: t = 16,
  ...i
}) => {
  const { fillColor: e, innerElementFill: n, strokeColor: c, setIsHovered: r } = s({
    color: "default",
    variant: C
  });
  return /* @__PURE__ */ o(
    "svg",
    {
      width: t,
      height: t,
      viewBox: "0 0 16 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      onMouseEnter: () => r(!0),
      onMouseLeave: () => r(!1),
      role: "img",
      ...i,
      children: [
        /* @__PURE__ */ o("g", { clipPath: "url(#clip0_16113_123)", children: [
          /* @__PURE__ */ l("circle", { cx: "8", cy: "8.25", r: "7.5", stroke: c, fill: e }),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M6.22217 11.7318C6.22217 11.6172 6.24885 11.4361 6.30222 11.1885C6.33335 11.0464 6.38004 10.8585 6.44231 10.6247L7.26282 7.46171C7.27171 7.42504 7.27838 7.38837 7.28283 7.35169C7.29173 7.31502 7.29617 7.28064 7.29617 7.24855C7.29617 7.06061 7.23836 6.94371 7.12273 6.89787C7.0071 6.85203 6.79586 6.82224 6.489 6.80848V6.43718C6.74694 6.41884 7.12051 6.38217 7.6097 6.32716C8.10334 6.26757 8.45245 6.21714 8.65702 6.17589L9.24406 6.05899L8.18339 10.0677C8.09445 10.4115 8.03441 10.6499 8.00328 10.7829C7.92323 11.1221 7.88321 11.3421 7.88321 11.443C7.88321 11.5438 7.90544 11.6103 7.94991 11.6424C7.99439 11.6699 8.04331 11.6836 8.09667 11.6836C8.23454 11.6836 8.40576 11.5621 8.61033 11.3192C8.8149 11.0762 8.99501 10.8218 9.15067 10.5559L9.45085 10.7554C9.00613 11.4292 8.66592 11.883 8.43021 12.1168C8.04331 12.5019 7.62971 12.6944 7.18944 12.6944C6.94039 12.6944 6.71581 12.6165 6.51568 12.4606C6.32001 12.3002 6.22217 12.0572 6.22217 11.7318ZM8.86382 2.91663C9.11731 2.91663 9.333 3.00831 9.51089 3.19167C9.68878 3.37503 9.77772 3.59736 9.77772 3.85865C9.77772 4.11994 9.68878 4.34456 9.51089 4.5325C9.333 4.71587 9.11731 4.80755 8.86382 4.80755C8.61033 4.80755 8.39241 4.71587 8.21008 4.5325C8.03219 4.34456 7.94324 4.11994 7.94324 3.85865C7.94324 3.59736 8.03219 3.37503 8.21008 3.19167C8.39241 3.00831 8.61033 2.91663 8.86382 2.91663Z",
              fill: n
            }
          )
        ] }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_16113_123", children: /* @__PURE__ */ l(
          "rect",
          {
            width: t,
            height: t,
            fill: e,
            transform: "translate(0 0.25)"
          }
        ) }) })
      ]
    }
  );
};
export {
  d as UtilityInfoIcon
};
//# sourceMappingURL=index.es453.js.map
